import { ChangeDetectorRef, Component } from '@angular/core';
import { ImportsModule } from "../../shared/imports.module";
import { Sociedad, Division, Usuario } from '../../shared/models';
import { CommonModule, CurrencyPipe, DatePipe, SlicePipe } from '@angular/common';
import { RolesService } from '../../shared/services/roles.service';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { saveAs } from 'file-saver';
import { finalize, Subject, takeUntil } from 'rxjs';
import { RolesUpdateComponent } from './formulario-roles/roles-update.component';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { PerfilStore } from '../../shared/store/perfil.store';
import { Router } from '@angular/router';

@Component({
  selector: 'app-roles',
  standalone: true,
  imports: [ImportsModule, CommonModule, CurrencyPipe, DatePipe, SlicePipe, NzSpinModule],
  templateUrl: './roles.component.html',
  styleUrl: './roles.component.scss'
})
export class RolesComponent {
  constructor(
    private rolesService: RolesService,
    private drawerService: NzDrawerService,
    private message: NzMessageService,
    private sessionStore: PerfilStore,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  usuarios ?: Usuario[] = [];
  usuariosFiltrados ?: Usuario[] = [];
  searchText?: string = '';
  loading = false;
  $onDestroy : Subject<void> = new Subject<void>();
  user : Usuario | null = null;

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.sessionStore
      .getPerfil()
      .pipe(takeUntil(this.$onDestroy))
      .subscribe((user:Usuario | null) => {
        this.user = user;
        if(!this.user?.esAdmin){
          this.$onDestroy.next();
          this.$onDestroy.complete();
          this.sessionStore.clearPerfil();
          this.router.navigate(['/']);
        }
        this.cargarUsuarios();
      });
  }

  ngOnDestroy() {
    this.$onDestroy.next();
    this.$onDestroy.complete();
  }

  cargarUsuarios() {
    this.loading = true;
    this.rolesService.obtenerListaUsuarios()
    .pipe(
      finalize(() => {
        this.loading = false;
        this.cdr.detectChanges();
      })
    )
    .subscribe(
      {
        next: (data) => {
          this.usuarios = data?.details as Usuario[];
          this.usuariosFiltrados = [...(this.usuarios ?? [])];
        },
        error: (error) => {
          console.error('Error al cargar usuarios:', error);
        }
      }
    )
  }


  onSearchChange( $event:any ) {
    this.searchText = $event.trim().toLowerCase();
    if (this.searchText?.length == 0) {
      this.usuariosFiltrados = [...this.usuarios!];
      return;
    }
    this.usuariosFiltrados = this.usuarios?.filter(usuario =>
      (usuario?.email && usuario.email.toLowerCase().includes(this.searchText!)) ||
      (usuario?.rol && usuario.rol.toLowerCase().includes(this.searchText!))
    );
  }

  AddSolicitud(){
    const drawer = this.drawerService.create(
      {
        nzTitle: 'Añadir Usuario',
        nzContent: RolesUpdateComponent,
        nzData: null,
        nzWidth: 600
      }
    )

    drawer.afterClose.subscribe( ( data ) => {
      if ( data ) {
        this.cargarUsuarios();
      }
    });
  }

  editarUsuario(usuario: Usuario) {
    const drawer = this.drawerService.create(
      {
        nzTitle: 'Editar Usuario',
        nzContent: RolesUpdateComponent,
        nzData: { usuario },
        nzWidth: 600
      }
    )

    drawer.afterClose.subscribe( ( data ) => {
      if ( data ) {
        this.cargarUsuarios();
      }
    });
  }


  eliminarUsuario(usuario: Usuario) {
    this.loading = true;
    this.rolesService.eliminarUsuario(usuario.usuarioId!)
    .pipe(
      finalize(() => {
        this.loading = false;
      })
    )
      .subscribe({
        next: () => {
          this.message.success(`Usuario ${usuario.email} eliminado correctamente`);
          this.cargarUsuarios();
        },
        error: (error) => {
          console.error('Error al eliminar usuario:', error);
          this.message.error(`Error al eliminar el usuario ${usuario.email}`);
        }
      });
  }

}
